import { Component, OnInit, OnDestroy } from '@angular/core';

@Component({
  selector: 'app-showroom-gallery',
  templateUrl: './showroom-gallery.component.html',
  styleUrls: ['./showroom-gallery.component.scss']
})
export class ShowroomGalleryComponent implements OnInit, OnDestroy {
  subcategoryName = 'Showroom Gallery';

  pageTitle = [
    {
      bgImage: 'assets/img/showroom-bg.jpg',
      title: this.subcategoryName
    }
  ];

  allImages: string[] = [
    // Excluded images
    'assets/img/showroom/IMG_1805.jpg',
    'assets/img/showroom/IMG_1806.jpg',
    'assets/img/showroom/IMG_1808.jpg',
    'assets/img/showroom/IMG_1784.jpg',
    'assets/img/showroom/IMG_1779.jpg',
    'assets/img/showroom/IMG_1780.jpg',
    'assets/img/showroom/IMG_1781.jpg',
    'assets/img/showroom/IMG_1787.jpg',
    'assets/img/showroom/IMG_1788.jpg',
    'assets/img/showroom/IMG_1789.jpg',
    'assets/img/showroom/IMG_1778.jpg',
    'assets/img/showroom/IMG_1775.jpg',
    'assets/img/showroom/IMG_1777.jpg',
    'assets/img/showroom/IMG_1793.jpg',
    'assets/img/showroom/IMG_1764.jpg',
    'assets/img/showroom/IMG_1754.jpg',
    'assets/img/showroom/IMG_1752.jpg',
    'assets/img/showroom/IMG_1757.jpg',
    'assets/img/showroom/IMG_1759.jpg',

    // Active image list
    'assets/img/showroom/IMG_1729.jpg',
    'assets/img/showroom/IMG_1730.jpg',
    'assets/img/showroom/IMG_1731.jpg',
    'assets/img/showroom/IMG_1732.jpg',
    'assets/img/showroom/IMG_1733.jpg',
    'assets/img/showroom/IMG_1734.jpg',
    'assets/img/showroom/IMG_1735.jpg',
    'assets/img/showroom/IMG_1736.jpg',
    'assets/img/showroom/IMG_1737.jpg',
    'assets/img/showroom/IMG_1738.jpg',
    'assets/img/showroom/IMG_1739.jpg',
    'assets/img/showroom/IMG_1740.jpg',
    'assets/img/showroom/IMG_1741.jpg',
    'assets/img/showroom/IMG_1742.jpg',
    'assets/img/showroom/IMG_1743.jpg',
    'assets/img/showroom/IMG_1744.jpg',
    'assets/img/showroom/IMG_1745.jpg',
    'assets/img/showroom/IMG_1746.jpg',
    'assets/img/showroom/IMG_1747.jpg',
    'assets/img/showroom/IMG_1748.jpg',
    'assets/img/showroom/IMG_1749.jpg',
    'assets/img/showroom/IMG_1750.jpg',
    'assets/img/showroom/IMG_1751.jpg',
    'assets/img/showroom/IMG_1753.jpg',
    'assets/img/showroom/IMG_1755.jpg',
    'assets/img/showroom/IMG_1756.jpg',
    'assets/img/showroom/IMG_1758.jpg',
    'assets/img/showroom/IMG_1760.jpg',
    'assets/img/showroom/IMG_1761.jpg',
    'assets/img/showroom/IMG_1762.jpg',
    'assets/img/showroom/IMG_1763.jpg',
    'assets/img/showroom/IMG_1765.jpg',
    'assets/img/showroom/IMG_1766.jpg',
    'assets/img/showroom/IMG_1767.jpg',
    'assets/img/showroom/IMG_1768.jpg',
    'assets/img/showroom/IMG_1769.jpg',
    'assets/img/showroom/IMG_1770.jpg',
    'assets/img/showroom/IMG_1771.jpg',
    'assets/img/showroom/IMG_1772.jpg',
    'assets/img/showroom/IMG_1773.jpg',
    'assets/img/showroom/IMG_1774.jpg',
    'assets/img/showroom/IMG_1776.jpg',
    'assets/img/showroom/IMG_1782.jpg',
    'assets/img/showroom/IMG_1783.jpg',
    'assets/img/showroom/IMG_1785.jpg',
    'assets/img/showroom/IMG_1786.jpg',
    'assets/img/showroom/IMG_1790.jpg',
    'assets/img/showroom/IMG_1791.jpg',
    'assets/img/showroom/IMG_1792.jpg',
    'assets/img/showroom/IMG_1794.jpg',
    'assets/img/showroom/IMG_1795.jpg',
    'assets/img/showroom/IMG_1796.jpg',
    'assets/img/showroom/IMG_1797.jpg',
    'assets/img/showroom/IMG_1798.jpg',
    'assets/img/showroom/IMG_1799.jpg',
    'assets/img/showroom/IMG_1800.jpg',
    'assets/img/showroom/IMG_1801.jpg',
    'assets/img/showroom/IMG_1802.jpg',
    'assets/img/showroom/IMG_1803.jpg',
    'assets/img/showroom/IMG_1804.jpg',
    'assets/img/showroom/IMG_1807.jpg',
    'assets/img/showroom/IMG_1809.jpg',
    'assets/img/showroom/IMG_1810.jpg'
  ];


  displayedImages: string[] = [];
  itemsPerPage = 8;
  currentPage = 1;

  isModalOpen = false;
  currentImage = '';

  private loadMoreCooldown = false;

  ngOnInit(): void {
    this.loadImages();
    window.addEventListener('keydown', this.handleKeyDown);
  }

  ngOnDestroy(): void {
    window.removeEventListener('keydown', this.handleKeyDown);
  }

  loadImages(): void {
    const endIndex = this.currentPage * this.itemsPerPage;
    this.displayedImages = this.allImages.slice(0, endIndex);
  }

  loadMore(): void {
    if (this.loadMoreCooldown) return;

    this.loadMoreCooldown = true;
    this.currentPage++;
    this.loadImages();

    // Prevent rapid clicking
    setTimeout(() => this.loadMoreCooldown = false, 500);
  }

  openModal(imgSrc: string): void {
    requestAnimationFrame(() => {
      this.currentImage = imgSrc;
      this.isModalOpen = true;
      document.body.style.overflow = 'hidden';
    });
  }

  closeModal(): void {
    this.isModalOpen = false;
    this.currentImage = '';
    document.body.style.overflow = '';
  }

  onImageLoad(event: Event): void {
    const img = event.target as HTMLImageElement;
    img.classList.add('loaded');
  }

  trackByFn(index: number, item: string): string {
    return item;
  }

  private handleKeyDown = (event: KeyboardEvent): void => {
    if (event.key === 'Escape') {
      this.closeModal();
    }
  };

  showNextImage(): void {
    const currentIndex = this.displayedImages.indexOf(this.currentImage);
    this.currentImage = this.displayedImages[(currentIndex + 1) % this.displayedImages.length];
  }

  showPreviousImage(): void {
    const currentIndex = this.displayedImages.indexOf(this.currentImage);
    this.currentImage = this.displayedImages[
      (currentIndex - 1 + this.displayedImages.length) % this.displayedImages.length
    ];
  }

}
